import script from "./SingleBet.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleBet.vue?vue&type=script&setup=true&lang=js"

import "./SingleBet.vue?vue&type=style&index=0&id=b57bd00a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b57bd00a"]])

export default __exports__